import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, withDefaults } from 'vue';
import {
    combinationsConfiguratorSteps,
    SEPARATED_BOXES_STEP_INDEX,
} from '@/modules/ConfiguratorCombinations/helpers/CombinationsConfiguration';

interface Props {
    value?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsSeparatedBoxes',
  props: {
    value: { type: Boolean, default: false }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {





const { proxy } = getCurrentInstance()!;

const title = combinationsConfiguratorSteps[SEPARATED_BOXES_STEP_INDEX]?.name ?? '';

function onChange(checked: boolean): void {
    emit('update', checked);
}

return { __sfc: true,emit, proxy, title, onChange }
}

})